// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Us-z","tupacHeader":"Vs-z","tupacHeader2":"Ws-z","tupacMenu":"Xs-z","tupacMenu2":"Ys-z","tupacMain":"Zs-z","tupacMain2":"_s-z"};